.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
}

.buttons {
  margin-top: calc(2 * var(--space-big));
  text-align: center;
}

.buttons > * {
  margin: var(--space-big);
}
